var _rect, _rect2, _rect3, _rect4, _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.6617,
    height: 13.5637,
    rx: 6.78184,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 9.59097 44)",
    fill: "#43BE7D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48.6617,
    height: 13.5637,
    rx: 6.78184,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 0 9.59082)",
    fill: "#43BE7D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.25854,
    y: 33.7462,
    width: 3.85304,
    height: 2.71274,
    rx: 1.35637,
    transform: "rotate(-45 4.25854 33.7462)",
    fill: "#FAF9FB",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0166,
    y: 14.5449,
    width: 14.5479,
    height: 2.71274,
    rx: 1.35637,
    transform: "rotate(-45 24.0166 14.5449)",
    fill: "#FAF9FB",
    fillOpacity: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_4002_1535",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13581 9.47466C6.60611 8.94497 5.74731 8.94497 5.21761 9.47466C4.68792 10.0044 4.68792 10.8632 5.21761 11.3929L15.9743 22.1495L8.86745 29.2564C8.33775 29.7861 8.33775 30.6449 8.86745 31.1746C9.39714 31.7043 10.2559 31.7043 10.7856 31.1746L18.7575 23.2028C18.7914 23.1748 18.8244 23.145 18.8561 23.1132C19.3858 22.5835 19.3858 21.7247 18.8561 21.195L7.13581 9.47466Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13581 9.47466C6.60611 8.94497 5.74731 8.94497 5.21761 9.47466C4.68792 10.0044 4.68792 10.8632 5.21761 11.3929L15.9743 22.1495L8.86745 29.2564C8.33775 29.7861 8.33775 30.6449 8.86745 31.1746C9.39714 31.7043 10.2559 31.7043 10.7856 31.1746L18.7575 23.2028C18.7914 23.1748 18.8244 23.145 18.8561 23.1132C19.3858 22.5835 19.3858 21.7247 18.8561 21.195L7.13581 9.47466Z",
    fill: "#14AE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21761 9.47466L1.68208 5.93913V5.93913L5.21761 9.47466ZM7.13581 9.47466L10.6713 5.93913L10.6713 5.93913L7.13581 9.47466ZM5.21761 11.3929L1.68208 14.9284H1.68208L5.21761 11.3929ZM15.9743 22.1495L19.5098 25.6851L23.0454 22.1495L19.5098 18.614L15.9743 22.1495ZM8.86745 29.2564L5.33191 25.7209L5.33191 25.7209L8.86745 29.2564ZM8.86745 31.1746L5.33191 34.7101L5.33192 34.7101L8.86745 31.1746ZM10.7856 31.1746L7.25011 27.6391L7.2501 27.6391L10.7856 31.1746ZM18.7575 23.2028L15.5814 19.3411L15.3937 19.4954L15.2219 19.6672L18.7575 23.2028ZM18.8561 21.195L15.3206 24.7305L18.8561 21.195ZM8.75315 13.0102C7.33022 14.4331 5.0232 14.4331 3.60027 13.0102L10.6713 5.93913C8.18903 3.45681 4.1644 3.45681 1.68208 5.93913L8.75315 13.0102ZM8.75315 7.85732C10.1761 9.28025 10.1761 11.5873 8.75315 13.0102L1.68208 5.93913C-0.800241 8.42145 -0.800231 12.4461 1.68208 14.9284L8.75315 7.85732ZM19.5098 18.614L8.75315 7.85732L1.68208 14.9284L12.4388 25.6851L19.5098 18.614ZM12.403 32.7919L19.5098 25.6851L12.4388 18.614L5.33191 25.7209L12.403 32.7919ZM12.403 27.6391C13.8259 29.062 13.8259 31.369 12.403 32.7919L5.33191 25.7209C2.8496 28.2032 2.8496 32.2278 5.33191 34.7101L12.403 27.6391ZM7.2501 27.6391C8.67304 26.2161 10.9801 26.2161 12.403 27.639L5.33192 34.7101C7.81422 37.1924 11.8389 37.1924 14.3212 34.7101L7.2501 27.6391ZM15.2219 19.6672L7.25011 27.6391L14.3212 34.7101L22.293 26.7383L15.2219 19.6672ZM15.3206 19.5777C15.4035 19.4948 15.4905 19.4158 15.5814 19.3411L21.9335 27.0644C22.0924 26.9338 22.2453 26.7951 22.3917 26.6487L15.3206 19.5777ZM15.3206 24.7305C13.8977 23.3076 13.8977 21.0006 15.3206 19.5777L22.3917 26.6487C24.874 24.1664 24.874 20.1418 22.3917 17.6595L15.3206 24.7305ZM3.60027 13.0102L15.3206 24.7305L22.3917 17.6595L10.6713 5.93913L3.60027 13.0102Z",
    fill: "#FAF9FB",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-1_4002_1535)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunCloseIcon);
export default __webpack_public_path__ + "static/media/funCloseIcon.b0b5ac39ad48bea7fa8e3e78f7c46e94.svg";
export { ForwardRef as ReactComponent };